import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';

import { triggerStickyFooterMobileIsViewed } from '../../actions';

import './StickyFooterMobile.scss';

export function StickyFooterMobile({ placement, config }) {
  const stickyFooterMobileRef = useRef();
  const dispatch = useDispatch();

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerStickyFooterMobileIsViewed());
  useTriggerSectionIsViewedGaEvent(stickyFooterMobileRef, dispatchTriggerSectionIsViewed);

  if (isEmpty(placement)) {
    return (null);
  }

  const {
    stickyFooterMobile: { shouldTrackInitialParams, rebateOptions },
    api: {
      contentParams,
      options: { sectionId },
    },
  } = config;
  const contentGroupIds = contentParams.map(({ content_group_id }) => content_group_id).join(',');
  const {
    merchant, couponCode, id, assets: { image, rolloverCopy, isImage150By150 },
  } = placement;
  const { showRebate, rebate } = merchant;

  return (
    <div
      className="mn_stickyFooter mn_stickyFooterMobile"
      data-content-group-ids={contentGroupIds}
      ref={stickyFooterMobileRef}
    >
      <ContentWrap>
        <OfferOverlayLink
          merchantId={merchant.id}
          merchantName={merchant.name}
          offerId={id}
          className="mn_stickyFooterMobileInner"
          sectionId={sectionId}
          data-merchant-id={merchant.id}
          data-merchant-name={merchant.name}
          shouldTrackInitialParams={shouldTrackInitialParams}
        >
          <div className="mn_stickyFooterContent">
            <div className={`mn_imageWrap ${isImage150By150 ? 'mn_imageWrap150By150' : '' }`}>
              <img className="mn_image" src={image} alt="" />
            </div>
            <div className="mn_merchantInfo">
              <h3>{merchant.name}</h3>
              { showRebate && <PremierMerchantRebate {...rebate} {...rebateOptions} /> }
              <p className="mn_rolloverCopy">{rolloverCopy}</p>
              { couponCode && <p className="mn_useCode">Use code: <span className="mn_code">{couponCode}</span></p> }
              <div className="mn_shopNow">Shop now</div>
            </div>
          </div>
        </OfferOverlayLink>
      </ContentWrap>
    </div>
  );
}

export default StickyFooterMobile;
